import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-label"]

import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Dialog from 'primevue/dialog';
import languageService from '@/services/language/language.service';
import LanguageOptions from '@/components/LanguageOptions.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore();
const display = ref(false);
const currentLanguage = computed(() => store.getters.currentLanguage ?? 'es');
const visible = computed(
  () =>
    store.getters.isLanguageSelectionEnabled &&
    route.meta.languageSelector === true
);

watch(visible, (isVisible) => {
  if (!isVisible) display.value = false;
});

async function change(language: string): Promise<void> {
  await languageService.change(language);
  display.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(visible))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "language-selector-button",
          type: "button",
          "aria-label": _ctx.$t('language.change'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (display.value = true))
        }, _toDisplayString(_unref(currentLanguage).toUpperCase()), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_unref(Dialog), {
      visible: display.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((display).value = $event)),
      modal: "",
      closable: false,
      header: _ctx.$t('language.title'),
      class: "language-selector-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(LanguageOptions, { onSelect: change })
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}
}

})